import { Dispatch, SetStateAction } from 'react';
import MainMenu from '../../MainMenu';
import SearchMobile from '../Search/Mobile';
import AllItems from './MenuItem/AllItems';
import Deals from './MenuItem/Deals';
import { HorizontalMenuItem } from '@/settings/menus/types';
import menu from '@/settings/menus';
import MenuItem from './MenuItem';
import SellYourDevice from './MenuItem/SellYourDevice';

const BottomNavbar = ({
  setShowMainMenu,
  showMainMenu,
}: {
  setShowMainMenu: Dispatch<SetStateAction<boolean>>;
  showMainMenu: boolean;
}) => {
  const menuItems: HorizontalMenuItem[] = menu;

  return (
    <>
      <SearchMobile toggle={() => setShowMainMenu(false)} />
      {/* Horizontal Menu */}
      <div className="md:flex lg:border">
        <div
          className="lg:reebelo-container w-full px-5 sm:px-8"
          id="inline-menu"
        >
          <div className="hidden h-fit items-center justify-between gap-3 py-2 text-[13px] sm:flex sm:pt-0 lg:py-2">
            <ul
              // eslint-disable-next-line tailwindcss/no-custom-classname
              className="hide-scrollbar flex h-full items-center gap-x-5 overflow-x-auto"
            >
              {/* All Items  */}
              <AllItems setShowMainMenu={setShowMainMenu} />
              {/* Deals */}
              <Deals />
              {/* Horizontal Menu Items  */}
              {menuItems.map((data) => {
                const { title, handle, pk } = data;

                return (
                  <MenuItem
                    key={data.handle ?? data.pk}
                    title={title}
                    handle={handle}
                    pk={pk}
                  />
                );
              })}
            </ul>
            <SellYourDevice />
          </div>
          {/* Main Menu */}
          <MainMenu
            showMainMenu={showMainMenu}
            setShowMainMenu={setShowMainMenu}
          />
        </div>
      </div>
    </>
  );
};

export default BottomNavbar;
